export * from './lib/vandijk-web-shell.module';
